import { useQuery } from '@tanstack/react-query'
import {
    getEditionsList,
    GetEditionsListOptions,
    DataLoaderGlobalParams,
} from '@news-mono/web-common'

// returns the latest TNO edition
export const useLatestOnEdition = (
    services: DataLoaderGlobalParams,
) => {
    const options: GetEditionsListOptions = {
        paging: {
            page: 1,
            pageSize: 1,
        },
        publication: 'the_nightly_on',
    }

    const { data } = useQuery({
        queryKey: ['get-latest-the-nightly-on-edition', services, options],
        queryFn: () => getEditionsList(services, options),
        staleTime: 1000 * 60,
        cacheTime: 1000 * 60 * 10,
    })

    const latestOnEdition =
        data?.documents && data.documents.length > 0
            ? data.documents[0]
            : undefined

    return {
        latestOnEdition,
    }
}
